/** Clinio Forms admin UI (staff-facing questionnaire management). */
export const FORMS_ADMIN_BASE_URL = 'https://forms.clinio.dk';

/** Patient-facing questionnaire fill-out host. */
export const FORMS_PATIENT_BASE_URL = 'https://forms.clinio.dk';

export type FormsAdminUrlOptions = {
  /** Forms tenant UUID — selects the clinic-linked workspace after login. */
  tenantId?: string | null;
  /** Path under the Forms origin, e.g. `/questionnaires/<id>/edit`. */
  path?: string;
};

/**
 * Build a Forms admin URL. When `tenantId` is set, appends `?tenant=` so Forms
 * opens the Clinio-linked organisation (CLISUP-58).
 */
export function formsAdminUrl(options: FormsAdminUrlOptions = {}): string {
  const path = options.path?.startsWith('/')
    ? options.path
    : options.path
      ? `/${options.path}`
      : '/';
  const url = new URL(path, FORMS_ADMIN_BASE_URL);
  if (options.tenantId) {
    url.searchParams.set('tenant', options.tenantId);
  }
  return url.toString();
}

export function formsResponseUrl(formsAssignmentId: string): string {
  return `${FORMS_ADMIN_BASE_URL}/responses/${formsAssignmentId}`;
}

/** Normalizes legacy forms.clinio.app links to forms.clinio.dk. */
export function normalizePatientFormsUrl(url: string): string {
  return url.replace('https://forms.clinio.app/', `${FORMS_PATIENT_BASE_URL}/`);
}

/** Reads cached public fill-out URL from patient_forms_assignments.metadata. */
export function publicUrlFromAssignmentMetadata(metadata: unknown): string | null {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return null;
  const url = (metadata as Record<string, unknown>).public_url;
  if (typeof url !== 'string' || !url.startsWith('https://')) return null;
  return normalizePatientFormsUrl(url);
}
